import 'whatwg-fetch';

function styleIframe(iFrame) {
  Object.entries({
    background: 'none',
    border: 'none',
    width: '100%',
    height: '100%',
  }).forEach((rule) => iFrame.style.setProperty(...rule));
}

const textHtmlLoader = ({ entryPoint }, element) => (
  new Promise((resolve, reject) => {   // eslint-disable-line
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'fullscreen');
    iframe.setAttribute('allow', 'clipboard-read');
    iframe.setAttribute('allowfullscreen', '');
    styleIframe(iframe);
    element.appendChild(iframe);
    resolve({
      getIframe: () => (iframe),
      load: () => { iframe.src = entryPoint; },
      getContentWindow: () => (iframe.contentWindow),
      addTitle: (title) => { iframe.setAttribute('title', title); },
      addClass: (className) => { iframe.classList.add(className); },
    });
  })
);

export const getPluginLoader = ({ contentType }) => {
  switch (contentType) {
    case 'application/embed':
      return textHtmlLoader;
    case 'text/html':
      return textHtmlLoader;
    default:
      return undefined;
  }
};

export const loadPluginView = (entryPoint, element) => {
  const pluginLoader = getPluginLoader(entryPoint);
  if (pluginLoader) {
    return pluginLoader(entryPoint, element);
  }
  return Promise.reject();
};

export const loadErrorView = (entryPoint, element) => {
  const errorElement = document.createElement('div');
  errorElement.innerHTML = `Error loading plugin ${entryPoint.pluginId} @ ${entryPoint.entryPoint}`;
  element.appendChild(errorElement); // todo:Anai WHY IS ELEMNET NULL? look into redux
};
